import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Bookmark } from 'lucide-react';
import { SAVED_BOOKS_QUERY } from '../shared/queries.ts';
import type { BookListItem } from '../shared/types.ts';
import { BookRow, BookListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/library/books',        label: 'For You', end: true },
  { to: '/library/books/all',    label: 'All Books' },
  { to: '/library/books/recent', label: 'Read' },
  { to: '/library/books/saved',  label: 'Saved' },
];

export function SavedBooks() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['books', 'saved'],
    queryFn: async () => {
      const res = await gql.request<{ savedBooks: BookListItem[] }>(SAVED_BOOKS_QUERY, { limit: 100 });
      return res.savedBooks;
    },
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Books" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <BookListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load books." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Bookmark size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">Nothing saved yet. Tap Save on a book to bookmark it for later.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((b) => <BookRow key={b.id} book={b} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
